import controller from './thing-chart.controller';

const template = require('./thing-chart.html');

require('./alert-chart-icon-16.png');
require('./warn-chart-icon-16.png');

export default {
    bindings: {
        thing: '<',
        eventReceived: '<'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-chart/thing-chart.component.js